import { useCallback } from "react";
import { trackEvents } from "../amplitude";

const FILTER_MODULE_MAP: Record<string, string> = {
  communication: "Communication",
  "campaign-communications": "Campaign Communications",
  campaigns: "Campaigns",
  "campaign-templates": "Campaign Templates",
  "campaign-logs": "Campaign Logs",
  "campaign-execution-logs": "Campaign Execution Logs",
  crm: "CRM",
  analytics: "Analytics",
  billing: "Billing",
  "playground-logs": "Playground Logs",
  "communication-analytics": "Communication Analytics",
  "pms-properties": "Property Management System",
  "pms-logs": "PMS Logs",
};

export const useFilterTracking = (filterType: string) => {
  const moduleName = FILTER_MODULE_MAP[filterType] || filterType;

  const trackFilterApplied = useCallback(
    (filterLabel: string, value: string) => {
      trackEvents("filter_applied", {
        filter_type: filterLabel,
        value: value || "cleared",
        module_name: moduleName,
      });
    },
    [moduleName],
  );

  const trackFilterCleared = useCallback(
    (filterLabel: string) => {
      trackEvents("filter_cleared", {
        filter_type: filterLabel,
        value: "cleared",
        module_name: moduleName,
      });
    },
    [moduleName],
  );

  const trackAllFiltersCleared = useCallback(() => {
    trackEvents("all_filters_cleared", {
      filter_type: "all",
      value: "cleared",
      module_name: moduleName,
    });
  }, [moduleName]);

  return { trackFilterApplied, trackFilterCleared, trackAllFiltersCleared };
};
